import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"
import { useNapForm } from "../NapFormContext"

interface NotesStepProps {
  childName?: string
  onNext: () => void
  onPrev?: () => void
  isSubmitting?: boolean
}

export function NotesStep({ childName, onNext, onPrev, isSubmitting = false }: NotesStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center">
        Any notes about {childName || 'your baby\'s'} nap?
      </h3>
      <div className="max-w-xl mx-auto space-y-2">
        <Textarea
          placeholder="Add any notes about the nap..."
          {...form.register("notes")}
          className="min-h-[80px] max-h-[200px]"
          onKeyDown={(e) => {
            // Prevent form submission on Enter key
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
            }
          }}
        />
        <div className="text-xs text-muted-foreground">
          <p>Press Shift + Enter for new line</p>
          <p className="mt-1">Suggested topics:</p>
          <ul className="mt-1 space-y-1 list-disc list-inside">
            <li>Sleep cues {childName || 'your baby'} showed</li>
            <li>Any disruptions during the nap</li>
            <li>{childName || 'Baby\'s'} mood before and after</li>
            <li>Changes to normal routine</li>
          </ul>
        </div>
      </div>
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={onNext}
          disabled={isSubmitting}
          className="ml-auto bg-purple-500 hover:bg-purple-600 text-white"
        >
          {isSubmitting ? "Saving..." : "Review & Save Nap"}
        </Button>
      </div>
    </div>
  )
}